export const connectionTypes = {
  bluetooth: 'BLUETOOTH',
  cellular: 'CELLULAR',
  ethernet: 'ETHERNET',
  wifi: 'WIFI',
  mixed: 'UNKNOWN',
  none: 'UNKNOWN',
  wimax: 'UNKNOWN',
  other: 'UNKNOWN',
  unknown: 'UNKNOWN'
};

// comment: navigator.connection поддерживается не всеми браузерами
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
export default (() => {
  return connectionTypes[globalThis.navigator?.connection?.type ?? 'unknown'];
});